import { render, staticRenderFns } from "./McNovice.vue?vue&type=template&id=9cfeec10&scoped=true&"
import script from "./McNovice.vue?vue&type=script&lang=js&"
export * from "./McNovice.vue?vue&type=script&lang=js&"
import style0 from "./McNovice.vue?vue&type=style&index=0&id=9cfeec10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfeec10",
  null
  
)

export default component.exports